import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import renderRoutes from 'react-router-config/renderRoutes';
import matchRoutes from 'react-router-config/matchRoutes';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Cookies from 'js-cookie';
import ErrorBoundary from '../../../components/error_boundary/error_boundary';
import DefaultError from '../../../components/error_boundary/default_error';
import { buildPostAdModel } from '../../../../utils/ad_util';
import adsConfig from '../../../../config/ads';
import matchMediaDesktop from '../../../../utils/client_util';
import Ad from '../../../components/ad/ad';
import Analytics from '../../../components/analytics/analytics';
// import Masthead from '../../../components/masthead/masthead';
// import navContext from '../../../components/masthead/nav_data';
import matchContext from '../../../../config/manual_param_set';
// import Recirc from '../../../components/recirc/recirc';
// import Footer from '../../../components/footer/footer';
import Config from '../../../components/config/config';
import Script from '../../../components/head/script';
import log from '../../../../services/logger_service';
import DetectAdBlock from '../../../components/ad/detect_ad_block';
import { canUseDOM } from 'exenv';

class Layout extends Component {
  constructor(props) {
    super(props);

    const adzoneParam = get(props, 'config.initialQueryParams.adzone');
    this.IS_QA_ADZONE = adzoneParam === 'qa';
    this.hasFooter = true;
    const routes = get(props, 'route.routes');
    const pathname = get(props, 'location.pathname');
    // console.log(matchRoutes(routes, pathname));
    if (routes && pathname) {
      this.chunks = matchRoutes(routes, pathname).reduce(function matchMap(
        list,
        item
      ) {
        if (item.match.url.includes('/fcw')) {
          const splitUrl = item.match.url.split('/');
          const param = item.match.params.page
            ? splitUrl[splitUrl.length - 2]
            : splitUrl[splitUrl.length - 1];
          const newParam = `${param.replace('-', '_')}_advertorial`;
          // eslint-disable-next-line no-param-reassign
          item.match.params.tag = newParam;
        }

        // This will manually set the params in cases where we can't pass them in the url
        matchContext.cases.forEach(foundCase => {
          if (item.match.url === foundCase.url) {
            // eslint-disable-next-line no-param-reassign
            item.match.params[foundCase.paramater] = foundCase.setTo;
          }
        });
        if (get(item, 'route.chunk')) {
          list.push(item.route.chunk);
        }
        return list;
      },
      []);
    } else {
      this.chunks = [];
    }

    this.state = {
      notification: {
        message: '',
        callback: () => {}
      },
      topNewsletterSignup: {
        show: false,
        callback: () => {}
      }
    };
  }

  componentDidMount() {
    this.setNotifications();

    this.setNewsletterSignupBar();

    if (!this.IS_QA_ADZONE) {
      // this.browsiScript();
    }

    this.setABTestCookie();
    this.setDailyCookie();
  }

  setABTestCookie() {
    if (!Cookies.get('abgroup')) {
      const groupBucket = Math.floor(Math.random() * 20) + 1;
      const cookieValue = String(groupBucket);
      Cookies.set('abgroup', cookieValue, { expires: 1 });

      if (canUseDOM) {
        window.digitalData.user[0].segment.abGroup = cookieValue;
      }
    }

    const abgroupQuery = get(this.props, 'config.initialQueryParams.abgroup');
    if (abgroupQuery) {
      Cookies.set('abgroup', abgroupQuery, { expires: 1 });

      if (canUseDOM) {
        window.digitalData.user[0].segment.abGroup = abgroupQuery;
      }
    }
  }

  setNotifications() {
    // if (!localStorage.getItem('notification-1')) {
    //   this.setState({
    //     notification: {
    //       message:
    //         'We use cookies to understand how you use our site and to improve your experience. This includes personalizing content and advertising. To view our updated Privacy Policy, effective July 19, 2018, in full, <a href="http://www.mansueto.com/privacy-policy/" target="_blank">click here.</a>',
    //       callback: () => this.closeNotification('notification-1')
    //     }
    //   });
    // }
  }

  setNewsletterSignupBar() {
    // Don't show on the following pages...
    const hiddenPages = [
      '/company/gucci',
      '/90348127/fast-company-european-innovation-fest-to-feature-alec-ross-ngozi-okonjo-iweala-jessica-brillhart-and-more',
      '/apply/innovation-by-design',
      '/apply/world-changing-ideas',
      '/apply/most-innovative-companies',
      '/apply/best-workplaces-for-innovators'
    ];

    const currentPathName = window.location.pathname;
    if (hiddenPages.some(path => currentPathName.indexOf(path) >= 0)) {
      return;
    }

    if (!localStorage.getItem('hide-newsletter-signup-topnav')) {
      this.setState({
        topNewsletterSignup: {
          show: true,
          callback: () =>
            this.closeNewsletterBar('hide-newsletter-signup-topnav')
        }
      });
    }
  }

  setDailyCookie() {
    if (window.localStorage.needToSetDailyCookie) {
      Cookies.set('dailycookie', 'true', { expires: 1 });
      window.localStorage.removeItem('needToSetDailyCookie');
    }
  }

  closeNotification(key) {
    localStorage.setItem(key, true);

    this.setState({
      notification: {
        message: '',
        callback: () => {}
      }
    });
  }

  closeNewsletterBar(key) {
    localStorage.setItem(key, true);

    this.setState({
      topNewsletterSignup: {
        show: false,
        callback: () => {}
      }
    });
  }

  livereload(env) {
    if (env === 'development') {
      return <script src="//localhost:35729/livereload.js" defer />;
    }
    return '';
  }

  scriptbundle(env) {
    if (env === 'development') {
      return [
        <script key="vendor" src="//localhost:3001/static/vendor.js" defer />,
        <script key="bundle" src="//localhost:3001/static/app.js" defer />
      ];
    }

    if (env === 'test') {
      return [
        <script
          key="vendor"
          src={`/js/${this.props.manifestJSON['vendor.js']}`}
          defer
        />,
        <script
          key="bundle"
          src={`/js/${this.props.manifestJSON['app.js']}`}
          defer
        />
      ];
    }

    return [
      <script
        key="vendor"
        src={`${this.props.manifestJSON['vendor.js']}`}
        defer
      />,
      <script key="bundle" src={`${this.props.manifestJSON['app.js']}`} defer />
    ];
  }

  scriptChunks(env) {
    if (env === 'development') {
      return null;
    }

    if (env === 'test') {
      return this.chunks.map(chunk => (
        <script
          key={chunk}
          src={`/js/${this.props.manifestJSON[`${chunk}.js`]}`}
          defer
        />
      ));
    }

    // dhm3b9kzksoul.cloudfront.net/bundle/js/23.bundle.948afa47006e5ca983f3.js
    return this.chunks.map(chunk => (
      <script
        key={chunk}
        src={`${this.props.manifestJSON[`${chunk}.js`]}`}
        defer
      />
    ));
  }

  browsiScript() {
    if (!matchMediaDesktop() && !document.querySelector('#browsi-tag')) {
      const script = document.createElement('script');
      script.src = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js';
      script.id = 'browsi-tag';
      script.setAttribute('data-pubkey', 'mansueto');
      script.setAttribute('data-sitekey', get(this.props, 'config.site', ''));

      document.querySelector('body').appendChild(script);
    }
  }

  topNavAd(location, site) {
    const adData = buildPostAdModel(adsConfig, site, null, 'homepage');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    return (
      <div className="homepage-page__ff-ad-container homepage-page__ff-ad-container--navtop">
        <Ad {...combinedAdModel} name="welcomemat" />
      </div>
    );
  }

  analyticsHeader() {
    // eslint-disable-next-line class-methods-use-this
    const listOfAnalytics = [
      'datalayer',
      'comscore',
      'nielsen',
      'googleAnalytics',
      'facebookPixel',
      'gdprConsent',
      'bombora'
    ];
    return <Analytics location="header" listOfAnalytics={listOfAnalytics} />;
  }

  analyticsFooter() {
    // eslint-disable-next-line class-methods-use-this
    const listOfAnalytics = [
      'comscore',
      'nielsen',
      'omniture',
      'parsely',
      'structuredData',
      'moatad',
      'skimlinks',
      'queryly',
      'chartbeat'
    ];
    return <Analytics location="footer" listOfAnalytics={listOfAnalytics} />;
  }

  postUp() {
    return (
      <Script
        type="text/javascript"
        innerHtml={
          "(function () {window.setTimeout(function() {var e = document.createElement('script'); e.type = 'text/javascript'; e.async = true; e.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'www.lightboxcdn.com/vendor/252af0a6-c9ae-4612-9dbe-5d1552fad623/lightbox_inline.js?mb=' + (new Date().getTime()); var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(e, s);}, 500);})();"
        }
      />
    );
  }

  es6Polyfill() {
    return (
      <Script
        type="text/javascript"
        src="https://cdn.polyfill.io/v2/polyfill.js?features=es6"
      />
    );
  }

  qualtricsFeedbackSnippet() {
    return (
      <Script
        type="text/javascript"
        innerHtml={`(function(){var g=function(e,h,f,g){this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g+ "&t=" + (new Date()).getTime();document.body&&document.body.appendChild(a)}};this.start=function(){var a=this;window.addEventListener?window.addEventListener("load",function(){a.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){a.go()})}};try{(new g(100,"r","QSI_S_ZN_2t6mDnUjRUuS8jH","https://zn2t6mdnujruus8jh-inc.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_2t6mDnUjRUuS8jH")).start()}catch(i){}})();`}
      />
    );
  }

  render() {
    const { pageType, config } = this.props;
    const featureFlags = get(config, 'featureFlags');
    const env = get(config, 'env', '');
    const site = get(config, 'site', '');

    // let activeCategory = '';
    // if (
    //   this.props.pageType === 'category' ||
    //   this.props.pageType === 'videoIndexPage' ||
    //   this.props.pageType === 'tag'
    // ) {
    //   activeCategory = location.pathname;
    // }
    const hasTopNavAd = featureFlags.topNavAdEnabled;

    let addedSpacingElements = '';

    if (
      this.state.topNewsletterSignup.show &&
      this.state.notification.message
    ) {
      addedSpacingElements = 'layout--notification-and-newsletter';
    }

    // if (this.state.topNewsletterSignup.show && !hasTopNavAd) {
    //  addedSpacingElements = 'layout--newsletter-signup';
    // }

    if (this.state.notification.message) {
      addedSpacingElements = 'layout--notification';
    }
    // TODO: Implement the spacing namespace instead of the individual ones directly below

    return (
      <body
        // className={`layout ${pageType ? `layout--${pageType}` : ''} ${
        //   hasTopNavAd ? 'layout--has-top-nav-ad' : ''
        // } ${
        //   this.state.topNewsletterSignup ? 'layout--newsletter-signup' : ''
        // } ${
        //   this.state.notification.message ? 'layout--notification' : ''
        // } ${site}`}
        className={`layout ${pageType ? `layout--${pageType}` : ''} ${
          hasTopNavAd ? 'layout--has-top-nav-ad' : ''
        } ${addedSpacingElements} ${site}`}
      >
        {this.analyticsHeader()}

        {this.qualtricsFeedbackSnippet()}
        <div id="ZN_2t6mDnUjRUuS8jH" />

        {/* {hasTopNavAd ? this.topNavAd(location, site) : null}
        <Masthead
          isHome={location.pathname === '/'}
          activeCategory={activeCategory}
          config={config}
          notification={this.state.notification}
          topNewsletterSignup={this.state.topNewsletterSignup}
          hasTopNavAd={hasTopNavAd}
          {...navContext[site]}
        /> */}
        <section className="main" role="main">
          <ErrorBoundary
            onError={(error, info) => {
              log.error(
                `Web Application Error: ${JSON.stringify(
                  error
                )}, ${JSON.stringify(info)}`
              );
            }}
            errorComponent={<DefaultError />}
          >
            {renderRoutes(this.props.route.routes)}
          </ErrorBoundary>
          {/* {!get(this.props, 'recircFeed.hide') && (
            <Recirc config={config} feed={recircFeed} />
          )} */}
        </section>
        {/* <Footer /> */}
        {this.analyticsFooter()}
        {this.es6Polyfill()}
        {this.livereload(env)}
        <Config />
        {this.scriptbundle(env)}
        {this.scriptChunks(env)}
        {this.IS_QA_ADZONE ? '' : this.postUp()}
        {canUseDOM && <DetectAdBlock pathname={window.location.pathname} />}
      </body>
    );
  }
}

function mapStateToProps(state) {
  return {
    config: state.config,
    manifestJSON: state.config.manifestJSON,
    staticVendorUrl: state.config.staticVendorUrl,
    staticBundleUrl: state.config.staticBundleUrl,
    pageType: state.context.type || '',
    recircFeed: {
      hide: get(state, 'recircFeed.hide'),
      fastcompany: get(state, 'recircFeed.data.fastcompany') || [],
      design: get(state, 'recircFeed.data.design') || [],
      ideas: get(state, 'recircFeed.data.ideas') || [], // to be updated to impact, work life, creativity
      entertainment: get(state, 'recircFeed.data.entertainment') || [], // to be updated to impact, work life, creativity
      leadership: get(state, 'recircFeed.data.leadership') || [] // to be updated to impact, work life, creativity
    },
    postFinite: get(state, 'postFinite.data.posts') || []
  };
}

Layout.propTypes = {
  route: PropTypes.shape({
    routes: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  config: PropTypes.shape({}).isRequired,
  manifestJSON: PropTypes.shape({
    'vendor.js': PropTypes.string,
    'app.js': PropTypes.string
  }).isRequired,
  staticBundleUrl: PropTypes.string.isRequired,
  staticVendorUrl: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  recircFeed: PropTypes.shape({
    hide: PropTypes.bool,
    fastcompany: PropTypes.arrayOf(PropTypes.shape({})),
    ideas: PropTypes.arrayOf(PropTypes.shape({})), // to be updated to impact, work life, creativity
    design: PropTypes.arrayOf(PropTypes.shape({})),
    entertainment: PropTypes.arrayOf(PropTypes.shape({})) // to be updated to impact, work life, creativity
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(Layout));
